import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";

// Only document formatting is allowed. Uploaded HTML, scripts, embeds and remote
// images cannot add executable content or track a reader's IP address.
const elements = ["h1", "h2", "h3", "h4", "h5", "h6", "p", "strong", "em", "del", "a", "ul", "ol", "li", "blockquote", "hr", "pre", "code", "table", "thead", "tbody", "tr", "th", "td", "br"];
export default function GuideMarkdown({ children }) {
  return <div className="guide-markdown text-sm leading-7 text-slate-300 break-words">
    <Markdown skipHtml allowedElements={elements} remarkPlugins={[remarkGfm]} components={{
      a: ({ href, children }) => {
        if (href?.startsWith("/") && !href.startsWith("//")) return <Link to={href}>{children}</Link>;
        if (/^https?:\/\//i.test(href || "")) return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
        return <span>{children}</span>;
      },
      table: ({ children }) => <div className="overflow-x-auto"><table>{children}</table></div>,
    }}>{children}</Markdown>
  </div>;
}
